export const SET_BM = 'setBM'
export const SET_BMS = 'setBMs'
export const SET_BM_CASH_FLOW = 'setBMCashFlow'
export const SET_ASSISTANTS = 'setAssistants'

export const SET_BM_DAYS_OFF = 'setBMDaysOff'
export const SET_BM_IMAGE = 'setBmImage'
export const BM_RESET = 'bmReset'
export const BM_RESET_SERVICE = 'bmResetService'
export const BM_RESET_WORKDAY = 'bmResetWorkDay'
export const BM_RESET_STATE = 'bmResetState'
export const BM_ADD_SERVICE = 'bmAddService'
export const BM_REMOVE_SERVICE = 'bmRemoveService'
export const BM_ADD_WEEKDAY = 'bmAddWeekDay'
export const BM_REMOVE_WEEKDAY = 'bmRemoveWeekDay'
export const SET_BM_PAGINATION = 'setBMItemsPerPage'
export const SET_BM_CASH_FLOW_PAGINATION = 'setBMCashFlowPagination'
export const SET_BM_ACTIVE = 'setBmActive'
export const SET_BM_DAY_OFF = 'setBmDayOff'
export const SET_BM_SERVICES = 'setBmServices'
export const SET_BM_SERVICE = 'setBmService'
export const BM_REMOVE_DAY_OFF = 'bmRemoveDayOff'
export const SET_BM_WORKDAY = 'setBmWorkDay'
export const SET_BM_WEEKDAYS = 'setBmWeekDays'
export const SET_BM_BALANCE = 'setBmBalance'